export enum PriceCategories {
  BasePrice = 'Base Price',
  Facing = 'Facing',
  CornerPremium = 'Corner Premium',
  Premium = 'Premium',
  Amenities = 'Amenities',
  View = 'View',
  OtherCharges = 'Other Charges'
}

export enum SubCategories {
  CarParking = 'Car Parking',
  TwoWheelerParking = 'Two Wheeler Parking'
}

export enum PriceTypes {
  BasePrices = 'Base Prices',
  OtherCharges = 'Other Charges'
}
